import React from 'react';
import NewPost from './NewPost';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import AdminPostList from './AdminPostList';

const Admin = () => {
  return (<div className="normal-route">
      <Button ><Link to="/new-post">Create New Post</Link></Button>
      <AdminPostList/>
  </div>);
};

export default Admin;
